import React from 'react';
import AnimatedContent from '../AnimatedContent';

const FEATURES = [
  {
    name: 'KI-Lebenslauf auf Maß',
    desc: 'Für jede Stelle wird aus deiner Erfahrungshistorie automatisch der passende Lebenslauf zusammengestellt. Kein Copy-paste, kein von vorne anfangen.',
  },
  {
    name: 'Ehrliches Feedback',
    desc: 'CVFlow gibt dir direktes Feedback auf Anschreiben und Lebenslauf – wie ein ehrlicher Mentor, der kein Blatt vor den Mund nimmt.',
  },
  {
    name: 'Bewerbungs-Cockpit',
    desc: 'Alle offenen Bewerbungen, ihr Status und deine nächsten Schritte auf einen Blick – damit du nie den Überblick verlierst.',
  },
];

export default function StepBumper() {
  return (
    <div className="ob-step-enter">
      <div className="ob-feature-list">
        {FEATURES.map((f, i) => (
          <AnimatedContent
            key={i}
            distance={40}
            direction="horizontal"
            reverse={false}
            duration={0.6}
            ease="power3.out"
            initialOpacity={0}
            animateOpacity
            delay={i * 0.15}
            threshold={0.1}
          >
            <div className="ob-feature-item">
              <div className="ob-feature-num">{i + 1}</div>
              <div>
                <div className="ob-feature-name">{f.name}</div>
                <div className="ob-feature-desc">{f.desc}</div>
              </div>
            </div>
          </AnimatedContent>
        ))}
      </div>
    </div>
  );
}
